"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsPerformanceBandSerializer = void 0;
var settings_performance_band_model_1 = require("../../../models/settings/settings-performance-band.model");
var SettingsPerformanceBandSerializer = /** @class */ (function () {
    function SettingsPerformanceBandSerializer() {
    }
    SettingsPerformanceBandSerializer.prototype.serialize = function (_a) {
        var code = _a.code, min = _a.min, max = _a.max;
        return new settings_performance_band_model_1.SettingsPerformanceBand({
            code: code,
            min: min,
            max: max,
        });
    };
    return SettingsPerformanceBandSerializer;
}());
exports.SettingsPerformanceBandSerializer = SettingsPerformanceBandSerializer;
